/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { HttpService } from '@angular-kit/core';
import { DataQuery } from '@typescript-kit/data';

import { TimeRecord, TimeRecordData } from '@teamworks/global';

@Injectable()
export class TimeRecordService {

  constructor(private httpService: HttpService) {
  }

  async loadTimeRecordList(dataQuery?: DataQuery): Promise<TimeRecord[]> {
    return this.httpService.get(`api/time-recording/time-record-list`, { 'data-query': dataQuery })
      .then((loadedData: TimeRecordData[]) => loadedData.map(data => new TimeRecord(data)));
  }

  async loadProjectTimeRecordListByMonth(projectId: string, year: string, month: string, dataQuery?: DataQuery): Promise<TimeRecord[]> {
    return this.httpService.get(`api/time-recording/project-time-record-list/${projectId}/${year}/${month}`, { 'data-query': dataQuery })
      .then((loadedData: TimeRecordData[]) => loadedData.map(data => new TimeRecord(data)));
  }

  async loadTimeRecordListByEmployee(employeeId: string, dataQuery?: DataQuery): Promise<TimeRecord[]> {
    return this.httpService.get(`api/time-recording/time-record-list/${employeeId}`, { 'data-query': dataQuery })
      .then((loadedData: TimeRecordData[]) => loadedData.map(data => new TimeRecord(data)));
  }

  async loadTimeRecordListByMonth(employeeId: string, year: string, month: string, dataQuery?: DataQuery): Promise<TimeRecord[]> {
    return this.httpService.get(`api/time-recording/time-record-list/${employeeId}/${year}/${month}`, { 'data-query': dataQuery })
      .then((loadedData: TimeRecordData[]) => loadedData.map(data => new TimeRecord(data)));
  }

  async saveTimeRecordList(timeRecordList: TimeRecordData[]): Promise<TimeRecord[]> {
    return this.httpService.post(`api/time-recording/time-record-list`, timeRecordList)
      .then((savedData: TimeRecordData[]) => savedData.map(data => new TimeRecord(data)));
  }

  // async loadTimeRecord(employeeId: string): Promise<TimeRecord> {
  //   return this.httpService.get(`api/time-recording/time-record/${id}`)
  //     .then((loadedData: TimeRecordData) => loadedData &&  new TimeRecord(loadedData));
  // }

  async saveTimeRecord(data: TimeRecordData): Promise<TimeRecord> {
    return this.httpService.post(`api/time-recording/time-record`, data)
      .then((savedData: TimeRecordData) => new TimeRecord(savedData));
  }

  async deleteTimeRecord(data: TimeRecordData): Promise<TimeRecord> {
    return this.httpService.delete(`api/time-recording/time-record/${data.employeeId}/${data.date}/${data.index}`)
      .then((deletedData: TimeRecordData) => new TimeRecord(deletedData));
  }
}
